import { getFullGoalDefinitionOptions, getFullInterventionDefinitionsOptions, type FullOrderViewModel } from '@generated';
import { useQuery } from '@tanstack/react-query';
import { type NewPredefinedInterventionState, type WizardAction, type WizardState } from './reducer/wizardReducer';
import { convertClientDateToServerDate } from '~/util/date';

export function useLoadDefinitions(wizardState: WizardState, dispatch: React.Dispatch<WizardAction>, fullOrder: FullOrderViewModel) {
	const newGoalDefinitionId =
		wizardState.selectedGoal && wizardState.selectedGoal.type === 'predefined' ? wizardState.selectedGoal.goalDefinition.id : undefined;

	const { data, isLoading } = useQuery({
		...getFullGoalDefinitionOptions(newGoalDefinitionId!, convertClientDateToServerDate(fullOrder.certificationPeriod.startDate)),
		enabled: wizardState.currentStep === 'LOAD_GOAL_DEFINITION',
		gcTime: 0,
		staleTime: 0
	});

	const newInterventionDefinitionIds = wizardState.selectedInterventions
		.filter(x => x.type === 'predefined' && x.interventionDefinition.hasDefinitionFields && !x.fullInterventionDefinition)
		.map(x => (x as NewPredefinedInterventionState).interventionDefinition.id)
		.toSorted((a, b) => a.localeCompare(b));

	const { data: fullInterventionDefinitions, isLoading: fullInterventionDefinitionsLoading } = useQuery({
		...getFullInterventionDefinitionsOptions(newInterventionDefinitionIds!.join(',')),
		enabled: wizardState.currentStep === 'LOAD_INTERVENTION_DEFINITIONS' && newInterventionDefinitionIds!.length > 0,
		gcTime: 0,
		staleTime: 0
	});

	if (wizardState.currentStep === 'LOAD_GOAL_DEFINITION' && data) {
		dispatch({ type: 'FULL_GOAL_DEFINITION_LOADED', fullGoalDefinition: data });
	} else if (wizardState.currentStep === 'LOAD_INTERVENTION_DEFINITIONS' && fullInterventionDefinitions) {
		dispatch({ type: 'FULL_INTERVENTION_DEFINITION_LOADED', fullInterventionDefinitions: fullInterventionDefinitions });
	}

	return isLoading || fullInterventionDefinitionsLoading;
}
